var map = {
	"./ReactHookCustom.js": 92048,
	"./ReactHookUseCallback.js": 43248,
	"./ReactHookUseContext.js": 19616,
	"./ReactHookUseEffect.js": 91435,
	"./ReactHookUseMemo.js": 82972,
	"./ReactHookUseReducer.js": 71036,
	"./ReactHookUseRef.js": 56096,
	"./ReactHookUseState.js": 12660
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52168;